import React from "react";
function highlight({
  init,
  HighLightComponent,
  supportLang
}) {
  let hljs;
  function isSupportLang(lang) {
    if (!(supportLang == null ? void 0 : supportLang.length))
      return true;
    if (!lang)
      return true;
    return supportLang.includes(lang);
  }
  return {
    viewerEffect({ markdownBody }) {
      (async () => {
        const els = markdownBody.querySelectorAll("pre>code");
        if (els.length === 0)
          return;
        if (!hljs) {
          hljs = await import("highlight.js").then((m) => m.default);
          if (init)
            await init(hljs);
        }
        els.forEach((el) => {
          hljs.highlightElement(el);
        });
      })();
    },
    mdxHandlerList: ({ ctx }) => (input) => {
      if ("res" in input)
        return input;
      const node = input.source;
      if (node.type !== "code")
        return input;
      const language = node.lang || "";
      if (!isSupportLang(language))
        return input;
      const code = node.value;
      const meta = node.meta;
      const props = {
        language,
        code,
        meta
      };
      return {
        res: /* @__PURE__ */ React.createElement(
          HighLightComponent,
          {
            ...props,
            ...ctx.calcRequireIndexProps(input)
          }
        )
      };
    }
  };
}
export {
  highlight
};
